module.exports = __webpack_public_path__ + "img/couples-013.e8703562.jpg";